/**
 * Header clock, HH:MM in the restaurant's time zone (the server-rendered value
 * may come from a cached page, so it is refreshed right away).
 */
const formatter = new Intl.DateTimeFormat('de-CH', {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'Europe/Zurich',
})

export function startClock() {
  const tick = () => {
    const now = new Date()
    const time = formatter.format(now)

    document.querySelectorAll('[data-clock]').forEach((clock) => {
      if (clock.textContent !== time) {
        clock.textContent = time
        clock.setAttribute('datetime', time)
      }
    })

    // Re-align to the next full minute instead of drifting with setInterval.
    window.setTimeout(tick, 60_000 - (now.getTime() % 60_000) + 50)
  }

  tick()
}
